import * as React from 'react';
import { FooterCommon } from './FooterCommon';

export default function Footer() {
  return <FooterCommon />;
}
